import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const icon = `${process.env.PUBLIC_URL}/img/burger.svg`;

class TopbarSidebarButton extends PureComponent {
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
  };

  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility } = this.props;

    return (
      <div>
        <button type="button" className="topbar__button topbar__button--desktop" onClick={changeSidebarVisibility}>
          <svg
            className="topbar__button-icon"
            width="16px"
            height="14px"
            viewBox="0 0 16 14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="black">
              <rect x="0" y="0" width="16" height="2" rx="1" />
              <rect x="0" y="6" width="16" height="2" rx="1" />
              <rect x="0" y="12" width="16" height="2" rx="1" />
            </g>
          </svg>
        </button>
        <button type="button" className="topbar__button topbar__button--mobile" onClick={changeMobileSidebarVisibility}>
          <svg
            className="topbar__button-icon"
            width="16px"
            height="14px"
            viewBox="0 0 16 14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="black">
              <rect x="0" y="0" width="16" height="2" rx="1" />
              <rect x="0" y="6" width="16" height="2" rx="1" />
              <rect x="0" y="12" width="16" height="2" rx="1" />
            </g>
          </svg>
        </button>
      </div>
    );
  }
}

export default TopbarSidebarButton;
